import { render, staticRenderFns } from "./EntranceManageIndex.vue?vue&type=template&id=4ee4a6f4&scoped=true"
import script from "./EntranceManageIndex.vue?vue&type=script&lang=js"
export * from "./EntranceManageIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ee4a6f4",
  null
  
)

export default component.exports